// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__1yMJQ","col":"CardReaderDesc_col__1_3dC","label":"CardReaderDesc_label__xWLSm"};